<template>
  <article
    :class="['library-card', {
      'library-card--picked': isPicked,
      'library-card--soon': !isPublished,
    }]"
  >
    <div class="library-card__top">
      <span class="library-card__tile"><component :is="document.icon" /></span>
      <button
        v-if="isPublished"
        type="button"
        :class="['library-card__pick', { 'library-card__pick--active': isPicked }]"
        :aria-pressed="String(isPicked)"
        @click="$emit('toggle', document.slug)"
      >
        {{ label(isPicked ? 'picked' : 'pick') }}
      </button>
      <span v-else class="library-card__soon">{{ label('soon') }}</span>
    </div>
    <span class="library-card__tag" v-html="documentText('tag')"></span>
    <h3 class="library-card__title" v-html="documentText('title')"></h3>
    <p class="library-card__text" v-html="documentText('text')"></p>
    <router-link
      v-if="isPublished"
      class="library-card__more"
      :to="{ name: 'resource-document', params: { slug: document.slug } }"
    >
      {{ label('more') }} <span aria-hidden="true">→</span>
    </router-link>
  </article>
</template>

<script>
import { textBlock } from '@/entities/text-block';
import {
  getResourceDocumentTextGroup,
  RESOURCE_DOCUMENT_STATUSES,
  RESOURCES_HUB_TEXT_PAGE,
} from '@/features/agent-resources/config';

export default {
  mixins: [ textBlock ],
  props: {
    document: {
      type: Object,
      required: true,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isPublished() {
      return this.document.status === RESOURCE_DOCUMENT_STATUSES.PUBLISHED;
    },
    isPicked() {
      return this.isPublished && this.selected;
    },
  },
  methods: {
    label(key) {
      return this.getKeyValueListBlockValue(RESOURCES_HUB_TEXT_PAGE, 'library-labels', key);
    },
    documentText(key) {
      return this.getKeyValueListBlockValue(RESOURCES_HUB_TEXT_PAGE, getResourceDocumentTextGroup(this.document.id), key);
    },
  },
};
</script>

<style lang="scss" scoped>
.library-card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 24px;
  border-radius: 28px;
  background: #FFFFFF;
  box-shadow: 0 8px 32px rgba(97, 113, 228, 0.08);

  &--picked {
    background: #EBF2FF;
    box-shadow: inset 0 0 0 2px #6171E4;

    .library-card__tile {
      background: #FFFFFF;
    }
  }

  &--soon {
    background: #F9FBFF;
    box-shadow: inset 0 0 0 1px #E3EAF8;
    opacity: .75;
  }

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 12px;
  }

  &__tile {
    flex: none;
    width: 48px;
    height: 48px;
    border-radius: 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #EBF2FF;
  }

  &__pick {
    appearance: none;
    border: 0;
    cursor: pointer;
    min-height: 36px;
    padding: 8px 14px;
    border-radius: 999px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 14px;
    background: #EBF2FF;
    color: #4555CC;

    &--active {
      background: #4555CC;
      color: #FFFFFF;
    }
  }

  &__soon {
    padding: 6px 12px;
    border-radius: 999px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 14px;
    background: #F0F1F3;
    color: #494E53;
  }

  &__tag {
    font-size: 13px;
    font-weight: 600;
    letter-spacing: .04em;
    text-transform: uppercase;
    color: #4555CC;
  }

  &__title {
    margin: 0;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 500;
    font-size: 21px;
    line-height: 27px;
  }

  &__text {
    margin: 0;
    font-size: 15px;
    line-height: 22px;
    color: #494E53;
  }

  &__more {
    margin-top: auto;
    padding-top: 6px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-family: 'IBM Plex Sans', sans-serif;
    font-weight: 600;
    font-size: 16px;
    color: #4555CC;
    text-decoration: none;

    &:hover {
      color: #373A3D;
    }
  }
}
</style>
